import BaseImageIcon from "./BaseImageIcon.vue";

export * from "./BaseImageIcon.vue";
export default BaseImageIcon;
